import React from 'react';
import { Paper, Box, Stack, Typography, Button } from '@mui/material';

function toFriendlyStatus(status) {
    if (!status) return '';
    return String(status).replace(/_/g, ' ');
}

function RequestCard({ req, onVote, onOpen, showOwnerActions, onEdit, onDelete }) {
    return (
        <Paper variant="outlined" sx={{ p: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box sx={{ minWidth: 64, textAlign: 'center' }}>
                <Button size="small" variant={req.hasVoted ? 'contained' : 'outlined'} onClick={onVote}>
                    {req.voteCount ?? 0}
                </Button>
                <Typography variant="caption" display="block">votes</Typography>
            </Box>
            <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography variant="subtitle1" fontWeight={600}>{req.title}</Typography>
                <Typography variant="body2" color="text.secondary" noWrap>
                    {req.description}
                </Typography>
                <Stack direction="row" spacing={1} sx={{ mt: 0.5 }}>
                    <Typography variant="caption" color="text.secondary">{req.category || 'uncategorized'}</Typography>
                    <Typography variant="caption" color="text.secondary">•</Typography>
                    <Typography variant="caption" color="text.secondary">{toFriendlyStatus(req.status)}</Typography>
                </Stack>
            </Box>
            <Stack direction="row" spacing={1}>
                <Button size="small" onClick={onOpen}>Open</Button>
                {showOwnerActions && (
                    <>
                        <Button size="small" onClick={onEdit}>Edit</Button>
                        <Button size="small" color="error" onClick={onDelete}>Delete</Button>
                    </>
                )}
            </Stack>
        </Paper>
    );
}

export default RequestCard;


